import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ImplementationStatusModel } from 'src/app/models/implementation-status.model';
import * as TextConstants from '../../constants/text.constants';
import { MecsImplementationStatusModel } from 'src/app/models/mecs-models/mecs-implementation-status.model';

@Component({
  selector: 'app-mecs-implementation-status',
  templateUrl: './mecs-implementation-status.component.html',
  styleUrls: ['./mecs-implementation-status.component.scss'],
})
export class MecsImplementationStatusComponent implements OnInit {
  @Input() subheading!: string;
  @Input() data!: MecsImplementationStatusModel;
  @Input() femalePopulationWithInfertility!: number;

  textConstants = TextConstants;
  cardWidths: string[] = [];

  ngOnInit() {
    this.setCardWidths(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setCardWidths(event.target.innerWidth);
  }

  setCardWidths(width: number) {
    if (width <= 600) {
      this.cardWidths = ['100%', '100%', '100%', '100%', '100%'];
    } else if (width <= 768) {
      this.cardWidths = ['45%', '40%', '34%', '28%', '22%'];
    } else if (width <= 1024) {
      this.cardWidths = ['50%', '45%', '38%', '32%', '26%'];
    } else {
      this.cardWidths = ['56%', '49.65%', '43.32%', '36.99%', '30.66%'];
    }
  }

}
